var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.31067 28.9363L4.31101 28.9366C4.85798 29.4763 5.7418 29.4766 6.28868 28.9364L15.7998 19.5428L23.5609 27.2082C24.1077 27.7486 24.9921 27.7487 25.5389 27.2083C25.539 27.2082 25.539 27.2082 25.5391 27.2081L35.3985 17.4705V21.0371C35.3985 21.8115 36.0321 22.4281 36.8001 22.4281C37.5682 22.4281 38.2019 21.8116 38.2019 21.0371V14.1236C38.2019 13.3495 37.5683 12.7325 36.8001 12.7325H29.8002C29.0323 12.7325 28.3983 13.3493 28.3983 14.1236C28.3983 14.8978 29.0323 15.5147 29.8002 15.5147H33.4047L24.55 24.2598L16.7888 16.5944C16.2419 16.0538 15.3578 16.054 14.8108 16.5943L4.31083 26.9646L4.31082 26.9646C3.76034 27.5084 3.76055 28.3925 4.31067 28.9363Z",
    fill: "#324395",
    stroke: "#324395",
    strokeWidth: 1.05357,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendIcon);
export default __webpack_public_path__ + "static/media/TrendIcon.e41d7bdd4562b1618f27d54833d8292b.svg";
export { ForwardRef as ReactComponent };